var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"battles-filter-sort",class:[  'sort-' + _vm.battlesFilterSortGames ]},[_vm._v(" SORT BY "),_c('span',[_vm._v("DATE")]),_c('button',{on:{"click":function($event){return _vm.battlesSetFilterSortGames(_vm.battlesFilterSortGames === 'date' ? 'price' : 'date')}}}),_vm._v(" SORT BY "),_c('span',[_vm._v("PRICE")])])
}
var staticRenderFns = []

export { render, staticRenderFns }